import { WhatYouWantOptionsType } from './types';

export const WHAT_YOU_WANT_OPTIONS: WhatYouWantOptionsType = [
  { id: 'deep_connection', title: '💖 Deep, emotional connection' },
  { id: 'stable_relationship', title: '🫶 Sweet, stable relationship' },
  { id: 'flirty_fun', title: '🔥 Flirty fun and casual dates' },
  { id: 'one_night_stand', title: '💦 Passionate one-night stand' },
  { id: 'just_talk', title: '💬 Just someone to talk to' },
];
